<template>
  <div class="view vip-view has-footer">
    <HeaderBar  />
    <!-- <NameCard /> -->
    <div class="view__wrap">
      <van-swipe>
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <div class="swiper-banner-wrap">
          <BannerItem v-bind="item" />
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="view-list-wrap">
      <div class="header">
        <span class="text--header">VIP推荐智库</span>
      </div>
      <div class="digital-list list">
        <DigitalItem v-for="item in digitalList" :key="item.id" v-bind="item" />
      </div>
    </div>
    
    <div class="view-list-wrap">
      <div class="header">
        <span class="text--header">VIP学院</span>
      </div>
      <div class="college-list list">
        <CourseItem v-for="item in courseList" :key="item.id" v-bind="item" />
      </div>
    </div>
    </div>
    
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';

import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
import NameCard from '../../components/NameCard';
import BannerItem from '../../components/BannerItem';
import DigitalItem from '../../components/DigitalItem';
import CourseItem from '../../components/CourseItem';
export default {
  name: 'vip',
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    HeaderBar,
    NameCard,
    BannerItem,
    DigitalItem,
    CourseItem
  },
  data() {
    return {
      bannerList: [],
      courseList: [],
      digitalList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getVip();
      this.getVipCourses();
      this.getVipDigital();
    },

    async getVip() {
      const res = await apiUtil.post(apiConst.getVip);
      if (res.success) {
        this.bannerList = res.banner;
      }
    },

    async getVipCourses() {
      const res = await apiUtil.post(apiConst.getVipMore, { type: 1 });
      if (res.success) {
        this.courseList = res.list;
      }
    },

    async getVipDigital() {
      const res = await apiUtil.post(apiConst.getVipMore, { type: 2 });
      if (res.success) {
        this.digitalList = res.list;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.vip-view {
  height: 100%;


  .name-card-comp {
    margin: 22px auto;
  }
  .swiper-banner-wrap{
    margin: 30px auto;
    width: 690px;
		height: 273px;

    .banner-item-comp {
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 12px;
      overflow hidden
		}
  }

  .view-list-wrap {
    .list {
      margin: 30px 15px 0 15px
      .digital-item-comp{
        margin: 15px
      }
      .course-item-comp{
        margin: 15px
      }
    }
  }
}
</style>
